import {Component, OnInit, ViewChild} from '@angular/core';
import {ServerPageRequest} from '../../classes/common/table/server-page-request';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import {VoipPeerApiService} from '../../services/api/network/online/voip-peer/voip-peer-api.service';
import {PageEvent} from '@angular/material/paginator';
import {PeerConnectionApiService} from '../../services/api/peer-connection/peer-connection-api.service';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';
import {CacProfilesApiService} from '../../services/api/routing/cac-profiles/cac-profiles-api.service';
import {MatDialog} from '@angular/material/dialog';
import {VoipPeersDialogComponent} from './voip-peers-dialog/voip-peers-dialog.component';
import {ConfirmationDialogComponent} from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {LogicalConjunctionService} from '../../services/common/logical-conjunction/logical-conjunction.service';
import {SnackBarService} from '../../services/common/snack-bar/snack-bar.service';
import * as _ from 'lodash';
import {SearchTermDefinitionInf} from '../../interfaces/common/search/search-term-definition-inf';
import {TableColumnsConfigurationDialogComponent} from '../../dialogs/table-columns-configuration-dialog/table-columns-configuration-dialog.component';
import {VoipPeersSearchComponent} from './voip-peers-search/voip-peers-search.component';
import Search from '../../utils/search';
import {ArmTableComponent} from '../../components/arm-table/arm-table.component';
import {LoaderService} from '../../services/common/loader-service/loader.service';
import {VoipPeersDialogService} from './voip-peers-dialog/voip-peers-dialog.service';

@Component({
  selector: 'voip-peers',
  templateUrl: './voip-peers.component.html',
  styleUrls: ['./voip-peers.component.scss']
})
export class VoipPeersComponent implements OnInit {
  voipPeersSearchComponent = VoipPeersSearchComponent;

  search: any = {};
  items: Array<any>;
  selection: any;
  isUnauthorized: boolean;
  data = {elements: [], totalElements: 0};
  searchData;

  peerConnections = [];
  cacProfilesOptions;

  serverPageRequest: ServerPageRequest = new ServerPageRequest({
    pageIndex: 0,
    pageSize: 25,
    length: 0
  });

  @ViewChild(ArmTableComponent) armTable;

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'name', display: 'Name', selected: true, width: 200},
    {name: 'deviceType', display: 'Type', selected: true, width: 200},
    {name: 'cacProfileName', display: 'CAC Profile', selected: true, width: 200},
    {name: 'cacState', display: 'CAC State', selected: true, width: 200},
    {name: 'pcons', display: 'Peer Connections', selected: true, width: 200}
  ];

  isMultipleSelection = true;

  searchTerms: SearchTermDefinitionInf[] ;

  constructor(private voipPeerApiService: VoipPeerApiService,
              private peerConnectionsApiService: PeerConnectionApiService,
              private logicalConjunctionService: LogicalConjunctionService,
              private voipPeersDialogService: VoipPeersDialogService,
              private cacProfileApiService: CacProfilesApiService,
              private userPrivilege: UserPrivilegeService,
              private snackBarService: SnackBarService,
              private loaderService: LoaderService,
              public dialog: MatDialog) { }


  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();

    this.refresh();
  }

  editItem(): void {
    this.voipPeersDialogService.edit(_.cloneDeep(this.selection[0]), () => {
      this.refresh();
    });
   /* const dialogRef = this.dialog.open(VoipPeersDialogComponent, {
      data: {
        isEditMode: false,
        selectedItem: _.cloneDeep(this.selection[0]),
        cacProfiles: this.cacProfilesOptions
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.voipPeerApiService.editVoipPeer(result.selectedItem, result.selectedItem.id).then(() => {
        dialogRef.close();
        this.snackBarService.display(`"${result.selectedItem.name}" successfully edited`);
        this.refresh();
      });
    });*/
  }

  removeItem(): void {
    this.voipPeersDialogService.delete(this.selection, () => {
      this.refreshItems();
    });
    /*const ids = this.selection.map(voipPeer => voipPeer.id);

    const confirmationMessage = `Are you sure you want to delete ${ids.length === 1 ?
        `the VoIP peer: "${this.selection[0].name}"` :
        `${ids.length} VoIP Peers: ${this.logicalConjunctionService
            .generateAndDescription(this.selection, 'name')}`} ?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.voipPeerApiService.deleteVoipPeers(this.selection.map(item => item.id)).then(() => {
        dialogRef.close();
        this.refreshItems();
        this.snackBarService.display(`${this.logicalConjunctionService
            .generateAndDescription(this.selection, 'name')} successfully deleted`);
      });
    });*/
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  refresh(): void {
    const params = {...this.search, ...this.serverPageRequest};
    this.loaderService.showMainContainer();
    Promise.all([
      this.voipPeerApiService.getVoipPeers(params),
      this.peerConnectionsApiService.getPCons(),
      this.cacProfileApiService.getCacProfiles().toPromise()
    ]).then((data) => {
      this.data = data[0];
      this.peerConnections = data[1].elements;
      this.addAdditionalDataToItems();
      this.setSearchOptions(data[2].elements);
      this.loaderService.hideMainContainer();
    }).catch(err => {
      console.log(`Exception was thrown in VOIP Peer connections refresh ${err}`);
      this.loaderService.hideMainContainer();
    });
  }

  refreshItems(): void {
    const params = {...this.search, ...this.serverPageRequest};
    this.loaderService.showMainContainer();
    this.voipPeerApiService.getVoipPeers(params).then((data) => {
      this.data = data;
      this.addAdditionalDataToItems();
      this.loaderService.hideMainContainer();
    }).catch((error) => {
      console.log(`Exception was thrown in refresh VOIP Peer connections, reason: ${error}`);
      this.loaderService.hideMainContainer();
    });
  }

  pageChanged(pageInfo: PageEvent): void {
    this.serverPageRequest = new ServerPageRequest(pageInfo);

    this.refreshItems();
  }

  isSingleSelection(): boolean {
    return this.selection && this.selection.length === 1;
  }

  isAnySelection(): boolean {
    return  this.selection && this.selection.length > 0;
  }

  onSearch(data): void {
    this.armTable.firstPage();
    this.serverPageRequest.firstPage();
    this.search = data;

    this.refreshItems();
  }

  private setSearchOptions(cacProfiles): void {
    const cacStateOptions = [
      { text: 'Unblock', value: 'UNBLOCK' },
      { text: 'Blocked', value: 'BLOCK' },
      { text: 'Blocked for Incoming', value: 'BLOCK_INCOMING' },
      { text: 'Blocked for Outgoing', value: 'BLOCK_OUTGOING' },
    ];
    const peerConnectionsOptions = this.peerConnections.map(pc => {
      return {
        text: pc.name + ' (' + pc.nodeName + ')',
        value: pc.id
      };
    });
    this.cacProfilesOptions = Search.generateSearchOptions(cacProfiles, 'name', 'id');

    this.searchData = {
      cacStateOptions,
      peerConnections: peerConnectionsOptions,
      cacProfiles: this.cacProfilesOptions
    };

    this.searchTerms = [
      { term: 'name', operator: ':', displayName: 'Name' },
      { term: 'pConId', operator: '=', displayName: 'Peer Connection' , displayValue: Search.getOptionValue(peerConnectionsOptions)},
      { term: 'cacProfileId', operator: '=', displayName: 'CAC Profile' , displayValue: Search.getOptionValue(this.cacProfilesOptions)},
      { term: 'cacState', operator: '=', displayName: 'CAC State' , displayValue: Search.getOptionValue(cacStateOptions)},
    ];
  }

  private addAdditionalDataToItems(): void {
    const vpToPcon = _(this.peerConnections).groupBy(p => p.voipPeerId)
        .map((value, key) => ({vp: key, pCons: _.map(value, (v) => v.name + ' (' + v.nodeName + ')')}))
        .keyBy('vp')
        .value();

    this.data.elements.forEach(v => {
      if (vpToPcon[v.id]) {
        v.pcons = vpToPcon[v.id].pCons.join(', ');
      }
    });
  }

  openColumnsConfiguration(): void {
    const dialogRef = this.dialog.open(TableColumnsConfigurationDialogComponent, {
      width: '350px',
      data: {
        columns: this.displayedColumns
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      dialogRef.close();
    });
  }

  isVPNotLonely(): boolean {
    return this.selection.some(vp => {
      return !vp.pcons;
    });
  }
}
